import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { router, __router__ } from "./router";
import axios, { type AxiosResponse } from "axios";

import { AuthorizationTokenKey } from "@/constant/user";
import "@/styles/index.css";
import "@/styles/scrollbar.scss";
// 引入 vxe-table 核心样式
import 'vxe-table/lib/style.css'
// 引入 vxe-pc-ui 样式（包含 tooltip 组件）
import 'vxe-pc-ui/lib/style.css'
import XEUtils from 'xe-utils'
import { VxeTooltip } from 'vxe-pc-ui'

import {
  // 全局对象
  VXETable,

  // 表格功能
  // Filter,
  // Edit,
  // Menu,
  // Export,
  // Keyboard,
  // Validator,

  // 可选组件
  Column,
  Colgroup,
  // Grid,
  // Tooltip,
  // Toolbar,
  // Pager,
  // Form,
  // FormItem,
  // FormGather,
  // Checkbox,
  // CheckboxGroup,
  // Radio,
  // RadioGroup,
  // RadioButton,
  // Switch,
  // Input,
  // Select,
  // Optgroup,
  // Option,
  // Textarea,
  // Button,
  // Modal,
  // List,
  // Pulldown,

  // 表格
  Table
} from 'vxe-table'
import zhCN from 'vxe-table/es/locale/lang/zh-CN'
import 'vxe-table/styles/cssvar.scss'

// 按需加载的方式默认是不带国际化的，自定义国际化需要自行解析占位符 '{0}'，例如：
VXETable.setup({
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args)
})

function useTable(app: App) {
  // 表格功能
  // app.use(Filter)
  // .use(Edit)
  // .use(Menu)
  // .use(Export)
  // .use(Keyboard)
  // .use(Validator)

  // 可选组件
  app
    .use(Column)
    .use(Colgroup)
    // .use(Grid)
    // .use(Tooltip)
    // .use(Toolbar)
    // .use(Pager)
    // .use(Form)
    // .use(FormItem)
    // .use(FormGather)
    // .use(Checkbox)
    // .use(CheckboxGroup)
    // .use(Radio)
    // .use(RadioGroup)
    // .use(RadioButton)
    // .use(Switch)
    // .use(Input)
    // .use(Select)
    // .use(Optgroup)
    // .use(Option)
    // .use(Textarea)
    // .use(Button)
    // .use(Modal)
    // .use(List)
    // .use(Pulldown)

    // 安装表格
    .use(Table)
    .use(VxeTooltip)
}

axios.defaults.baseURL = "/api";

axios.interceptors.request.use((config) => {
  if (config.headers) {
    const token = sessionStorage.getItem(AuthorizationTokenKey);
    if (token !== null) {
      config.headers[AuthorizationTokenKey] = token;
    }
  }

  if (!config.paramsSerializer) {
    config.paramsSerializer = {};
  }
  config.paramsSerializer = { ...config.paramsSerializer, indexes: null };

  config.withCredentials = true;

  return config;
});

const handleResponse = (response: AxiosResponse) => {
  const token = response.headers[AuthorizationTokenKey];
  if (typeof token === "string" && token.length > 0) {
    sessionStorage.setItem(AuthorizationTokenKey, token);
  }
  if (response.status === 401) {
    if (window.location.pathname.indexOf("login") >= 0) {
      return Promise.reject(response);
    }
    const query: any = {
      redirectUrl: window.location
    };
    router.replace({
      name: "login",
      query: query
    });
  }
  return null;
};

axios.interceptors.response.use(
  (response) => {
    const result = handleResponse(response);
    if (result !== null) {
      return result;
    }
    return Promise.resolve(response);
  },
  (error) => {
    if (error.response) {
      const result = handleResponse(error.response);
      if (result !== null) {
        return result;
      }
    }
    return Promise.reject(error);
  }
);

const app = createApp(App);
app.use(useTable)

app.use(createPinia());

__router__.then(() => {
  app.use(router);
  app.mount("#app");
});
